import moment from 'moment';
import formats from '@/config/formats';
const SECONDS_IN_DAY = 24 * 60 * 60;
const MISSING_LEAP_YEAR_DAY = SECONDS_IN_DAY * 1000;
const MAGIC_NUMBER_OF_DAYS = 25567 + 2;
export const COMMON_DATE_STRING_FORMATS = ['MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD', 'MMM D, YYYY', 'MMMM D, YYYY', 'M/D/YY', 'D-MMM-YY', 'YYYY/MM/DD', 'DD MMM YYYY', 'MM-DD-YYYY', 'DD.MM.YYYY', 'YYYY.MM.DD', // Date and time formats
'MM/DD/YYYY HH:mm', 'MM/DD/YYYY hh:mm A', 'DD/MM/YYYY HH:mm', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ssZ', // ISO 8601
'YYYY-MM-DDTHH:mm:ss.SSSZ', // ISO 8601 with milliseconds
'YYYY-MM-DD HH:mm:ss.SSS', 'MMM D, YYYY h:mm A', 'MMMM D, YYYY h:mm A'];
export const nowUnix = () => Math.round(Date.now() / 1000); // Convert a date string to a date object
// use the local mode, assume date is in user's local
// timezone

export function dateStringToDate(input) {
  let isUtc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const parsed = isUtc ? moment.utc(input, COMMON_DATE_STRING_FORMATS, true) : moment(input, COMMON_DATE_STRING_FORMATS, true); // `true` = strict parsing

  return parsed.isValid() ? parsed.toDate() : null;
} // Convert a date object to an Excel date number
// https://github.com/oleg-koval/excel-date-to-js/blob/2800257a6e3872f18f903b163681dcb8434a02c8/index.js#L34

export function dateToExcelNumber(date) {
  try {
    return Number((date.getTime() / MISSING_LEAP_YEAR_DAY + MAGIC_NUMBER_OF_DAYS).toFixed(2));
  } catch {
    return NaN;
  }
}
export default {
  // Convert a UNIX timestamp to app's
  // User Date Display format
  toNumericDateDisplay(unixtimestamp) {
    return unixtimestamp ? moment.unix(unixtimestamp).format(formats.numericDateDisplay) : moment().format(formats.numericDateDisplay);
  },

  toFullNumericDateDisplay(unixtimestamp) {
    return unixtimestamp ? moment.unix(unixtimestamp).format(formats.fullNumericDateDisplay) : moment().format(formats.numericDateDisplay);
  },

  toDateString(unixtimestamp) {
    return unixtimestamp ? moment.unix(unixtimestamp).format(formats.dateString) : moment().format(formats.dateString);
  },

  toDateStamp(unixtimestamp) {
    return unixtimestamp ? moment.unix(unixtimestamp).format(formats.dateStamp) : moment().format(formats.dateStamp);
  },

  toFullTextDate(unixtimestamp) {
    return unixtimestamp ? moment.unix(unixtimestamp).format(formats.fullTextDate) : moment().format(formats.fullTextDate);
  },

  // UNIX to a time from date, e.g. 2 days ago
  toTimeFromDate(unixtimestamp) {
    return unixtimestamp ? moment.unix(unixtimestamp).fromNow() : moment().fromNow();
  },

  // UNIX to an ISO date string
  toIsoDate(unixtimestamp) {
    const ts = typeof unixtimestamp === 'number' ? unixtimestamp * 1000 : Date.now();
    const date = new Date(ts);
    return date.toISOString();
  },

  nowUnix,
  dateStringToDate,
  dateToExcelNumber
};